module.exports = __webpack_public_path__ + "static/img/banner4.043a92e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner4.jpg
// module id = jnCk
// module chunks = 1